exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@-webkit-keyframes spin-data-v-2c10d8a1 {\n0% {\r\n    transform: rotate(0deg) scaleX(-1);\n}\n100% {\r\n    transform: rotate(360deg) scaleX(-1);\n}\n}\n@keyframes spin-data-v-2c10d8a1 {\n0% {\r\n    transform: rotate(0deg) scaleX(-1);\n}\n100% {\r\n    transform: rotate(360deg) scaleX(-1);\n}\n}\n.spinning[data-v-2c10d8a1] {\r\n  -webkit-animation: spin-data-v-2c10d8a1 2s linear infinite;\r\n          animation: spin-data-v-2c10d8a1 2s linear infinite;\n}\r\n", ""]);

// exports
